/**
 * Render variables that are contained in a String.
 *
 * @param {string} text The text to parse.
 * @param {object} component The Vue component instance (this._self).
 */
export default function(text, component) {
  return (text || '').replace(/{{(.*?)}}/g, (x, prop = '') =>
    search(component, prop.trim())
  )
}

/**
 * Find a value in an Object using a String path
 *
 * Snippet from https://stackoverflow.com/a/51049199/9690395
 *
 * @param {object} haystack
 * @param {string} needle
 */
function search(haystack, needle) {
  return needle
    .replace(/\[|\]\.?/g, '.') // Convert to dot notation
    .split('.')
    .filter(s => s)
    .reduce((acc, val) => acc && acc[val], haystack)
}
